import React, { useEffect, useRef, useState } from "react";
import './Career.css';
import Navbar from "../Navbar/Navbar";
import bannerimg from './CareerImages/career banner img.png';
import bannericon from './CareerImages/banner icon.png';
import earthimg from './CareerImages/Ecology and earth day.png';
import growthimg from './CareerImages/growth columns.png';
import upload_icon from './CareerImages/uploadsymb.png';
import contact_icon from './CareerImages/contact us icon.png';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import UploadRoundedIcon from '@mui/icons-material/UploadRounded';
import Footer from '../Footer/Footer';
import { useNavigate } from "react-router-dom";

function Career() {
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();

    const handleOpenModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && file.size <= 2 * 1024 * 1024 && file.type === 'application/pdf') {
            // Process the file here (e.g., upload it to a server)
            console.log("File uploaded:", file.name);
        } else {
            alert("Please upload a PDF file below 2MB.");
        }
    };

    const renderOnlyOnce = useRef(false);
    useEffect(()=>{
        if(!renderOnlyOnce.current){
            window.scrollTo({behavior:'instant',top:0});
            renderOnlyOnce.current=true;
        }
    },[]);

    return (
        <>
            <div className='career-container'>
                <Navbar />
                <div className="career-bannercon">
                    <div className="career-text-section">
                    <div className="career-square-box1"></div>
                        <h1>Join <span className="career-highlight"><i>Our Mission</i></span> for Health <br /> Innovation</h1>
                        <p>Empowering people with access to quality healthcare <br />worldwide starts with our team.</p>
                        <div className="career-square-box2">
                    </div>
                    </div>

                    <div className="career-image-section">
                        <img src={bannerimg} alt="Team of healthcare professionals" />
                    </div>
                    
                    <div className="box-top-right"></div>
                    <div className="box-bottom-left"></div>
                    <div className="career-square-box3">
                    </div>

                    <div className="career-icon">
                        <img src={bannericon} alt="Science icon" />
                    </div>
                </div>


                <div className="career-why-ardescon">
                    <h1>Why Join Arde’s Laboratories?</h1>
                    <div className="career-section">
                        <div className="career-section-text">
                            <h2>Commitment to Excellence</h2>
                            <p>At Arde’s, we’re committed to investing in our people. We understand that career growth is essential, and we actively provide a range of professional development programs to help you advance and thrive in your role.</p>
                        </div>
                        <div className="career-section-image">
                            <div className="career-image-content">
                                <img src={growthimg} alt="Professional Growth" />
                            </div>
                        </div>
                    </div>

                    <div className="career-section">
                        <div className="career-section-text">
                            <h2>Empowering Innovative Thinking</h2>
                            <p>Arde’s is dedicated to staying at the forefront of pharmaceutical innovation. We embrace new technologies and encourage our teams to think outside the box, fostering a culture of curiosity and creativity.</p>
                        </div>
                        <div className="career-section-image">
                            <div className="career-image-content">
                                <img src={earthimg} alt="Innovative Environment" />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="career-resumecon">
                    <h1>Discover Your Next Career Step at Arde’s <br />Laboratories</h1>
                    <p>A brief, inviting line such as “Interested in working with us? Submit your resume <br /> below to explore opportunities at Arde’s Laboratories.</p>
                    <button onClick={handleOpenModal}>Upload your Resume <img src={upload_icon} alt="upload icon" /></button>
                </div>

                <div className="career-contact-con">
                    <div className="career-contact">
                        <div className="career-contact-cantent">
                            <h2>Questions? Get in Touch</h2>
                            <p>We’re here to help with any questions about your future at Arde’s Laboratories. Connect with us directly or explore our careers page to learn more.</p>
                            <button onClick={()=>navigate('/contactus')
                            }>Get In Touch <ArrowForwardRoundedIcon /></button>
                        </div>
                        <div className="career-contact-img">
                            <img src={contact_icon} alt="contact pic" />
                        </div>
                    </div>
                </div>

                {/* Modal Component */}
                {showModal && (
                    <div className="modal-overlay" onClick={handleCloseModal}>
                        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                            <div className="dropzone">
                                <input type="file" id="fileUpload" onChange={handleFileChange} accept=".pdf" />
                                <label htmlFor="fileUpload" className="dropzone-label">
                                    <div className="upload-icon"><UploadRoundedIcon sx={{ width: '50px', height: '50px' }} /></div>
                                    <p>Drop your file here, or <span className="browse-link">browse</span></p>
                                    <p className="file-info">supports: PDF file below 2MB</p>
                                </label>
                            </div>
                            <button onClick={handleCloseModal}>Close</button>
                        </div>
                    </div>
                )}
            </div>

            <Footer/>
        </>
    );
}

export default Career;
